import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  SimpleChanges
} from '@angular/core';
import { UtilityService } from '../../../../../../_services/utility.service';
import { ReflectionService } from '../../../../../../_services/reflection.service';
import { Reflection } from '../../../../../../models/reflection';

@Component({
  selector: 'app-reflection-widget',
  templateUrl: './reflection-widget.component.html',
  styleUrls: ['./reflection-widget.component.css']
})
export class ReflectionWidgetComponent {
  @Input() chosenUser?: string;
  @Input() isVisible: boolean;
  @Input() isEdit: boolean = false;
  @Input() selectedReviewId: number;
  @ViewChild('carouselExampleDark', { static: false }) carousel!: ElementRef;

  groupedReflections: any[] = [];
  isFirstSlide: boolean = true;
  isLastSlide: boolean = false;
  reflections: Reflection[];
  userProjects: any = [];
  dataReflections: any = [];

  constructor(
    private readonly utilityService: UtilityService,
    private readonly reflectionService: ReflectionService
  ) {}

  ngAfterViewInit(): void {
    if (!this.carousel) return;
    const carouselElement = this.carousel.nativeElement;

    carouselElement.addEventListener(
      'slide.bs.carousel',
      (event: any): void => {
        const totalSlides =
          carouselElement.querySelectorAll('.carousel-item').length;
        const activeIndex = event.to; // Indice della slide attuale

        this.isFirstSlide = activeIndex === 0;
        this.isLastSlide = activeIndex === totalSlides - 1;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.isVisible &&
      (changes['chosenUser']?.currentValue || this.chosenUser) &&
      changes['selectedReviewId']?.currentValue
    ) {
      this.getMyProjects();
      this.getReflections();
    }
  }

  getReflections(): void {
    this.reflectionService
      .getMyReflectionsAfterLastReview(this.chosenUser, this.selectedReviewId)
      .subscribe({
        next: (res: any): void => {
          this.dataReflections = res;
          this.reflections = res.result;

          this.groupedReflections = this.groupReflections(this.reflections, 3);

          this.isLastSlide = this.groupedReflections.length === 1;
        }
      });
  }

  /**
   * Raggruppa le riflessioni in base alla grandezza del gruppo
   *
   * @param reflections
   * @param groupSize
   */
  groupReflections(reflections: any[], groupSize: number): any[][] {
    const groupedReflections: any[] = [];
    for (let i: number = 0; i < reflections.length; i += groupSize) {
      groupedReflections.push(reflections.slice(i, i + groupSize));
    }
    return groupedReflections;
  }

  /**
   * Recupera i progetti dell'utente loggato per poterli inviare al componente Riflessioni
   *
   * @param year
   * @param month
   */
  getMyProjects(year: any = '', month: any = '') {
    let utility: UtilityService = this.utilityService;

    return this.reflectionService
      .getMyProjects(year, month, this.chosenUser)
      .subscribe({
        next: (res: any): void => {
          this.userProjects = res;

          this.userProjects?.result_course?.forEach(function (
            course: any
          ): void {
            course.filestorage.path = utility.getSanitizeUrl(
              course.filestorage.path
            );
          });

          this.userProjects?.result_project?.forEach(function (
            project: any
          ): void {
            project.filestorage.path = utility.getSanitizeUrl(
              project.filestorage.path
            );
          });

          this.userProjects?.result_mentoring?.forEach(function (
            mentoring: any
          ): void {
            mentoring.filestorage.path = utility.getSanitizeUrl(
              mentoring.filestorage.path
            );
          });
        }
      });
  }
}
